import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Pagination from "../components/pagination";
import Layout from "../components/layout";
import { fetchContracts } from "../services/contracts";
import ContractsList from "../components/contracts/contractsList";
// import DeployContract from "../components/contracts/deployContract"; // COMMENTED OUT
import useChainSettings from "../utils/hooks/chain/useChainSettings";

export default function Contracts() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [contracts, setContracts] = useState({
    items: [],
    page: 0,
    pageSize: 25,
    total: 0,
  });
  const [loading, setLoading] = useState(true);
  // const [showDeployForm, setShowDeployForm] = useState(false); // COMMENTED OUT
  const [searchTerm, setSearchTerm] = useState("");
  const { decimals, symbol } = useChainSettings();

  const page = parseInt(searchParams.get("page")) || 0;
  const pageSize = parseInt(searchParams.get("page_size")) || 25;

  useEffect(() => {
    setLoading(true);
    fetchContracts(page, pageSize)
      .then((data) => {
        setContracts(data);
      })
      .catch((error) => {
        console.error("Failed to fetch contracts:", error);
        setContracts({ items: [], page: 0, pageSize: 25, total: 0 });
      })
      .finally(() => {
        setLoading(false);
      });
  }, [page, pageSize]);

  // COMMENTED OUT - Deploy functionality
  // const handleDeploySuccess = () => {
  //   // Refresh contracts list
  //   setLoading(true);
  //   fetchContracts(page, pageSize)
  //     .then((data) => {
  //       setContracts(data);
  //     })
  //     .catch((error) => {
  //       console.error("Failed to fetch contracts:", error);
  //     })
  //     .finally(() => {
  //       setLoading(false);
  //     });
  //
  //   // Hide deploy form
  //   setShowDeployForm(false);
  // };

  // Filter contracts based on search term
  const filteredContracts = contracts.items.filter(
    (contract) =>
      contract.address.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (contract.name &&
        contract.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
      contract.creator.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  return (
    <Layout>
      <div className="page-container">
        {/* Deploy Contract Form - COMMENTED OUT */}
        {/* {showDeployForm && (
          <div style={{ marginBottom: "24px" }}>
            <DeployContract onDeploySuccess={handleDeploySuccess} />
          </div>
        )} */}

        <div className="content-card">
          <div className="card-header">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "16px",
              }}
            >
              <div>
                <h1 className="card-title">Smart Contracts</h1>
                <p className="card-subtitle">
                  All deployed smart contracts on REGAChain
                </p>
              </div>
              {/* Deploy button - COMMENTED OUT */}
              {/* <button
                onClick={() => setShowDeployForm(!showDeployForm)}
                className="deploy-button"
              >
                <span style={{ marginRight: "8px" }}>+</span>
                Deploy New Contract
              </button> */}
            </div>

            {/* Search Bar */}
            <div>
              <input
                type="text"
                placeholder="Search contracts..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-input"
              />
            </div>
          </div>

          <ContractsList
            contracts={filteredContracts}
            loading={loading}
            decimals={decimals}
            symbol={symbol}
          />

          <div style={{ padding: "16px" }}>
            <Pagination
              {...contracts}
              onPageChange={(newPage) => {
                setSearchParams({ page: newPage, page_size: pageSize });
              }}
            />
          </div>
        </div>
      </div>
    </Layout>
  );
}
